// Typed activity-feed endpoint functions. Backed by GET /api/v1/activity-feed.
//
// CHG-1643 / Wave 1 Tier 1 — port of v1 ActivityFeed.tsx +
// PlatformActivityFeed (same endpoint, scope=org|platform query param).
// Backend handler: src/api/app/routers/activity_feed.py.
//
// The backend envelope is {data, pagination:{page, per_page, total,
// total_pages}}; v2 ListPage expects {items, total}. Translation lives
// in listActivity() so the page-side config stays generator-shaped.

import { apiClient } from "./client";

export interface ActivityEntry {
  id: string;
  timestamp: string;
  category: string;
  icon: string;
  title: string;
  description: string;
  actor_name?: string | null;
  actor_email?: string | null;
  entity_type?: string | null;
  entity_id?: string | null;
  entity_name?: string | null;
  org_id?: string | null;
  org_name?: string | null;
  metadata?: Record<string, unknown> | null;
}

interface ActivityEnvelope {
  data: ActivityEntry[];
  pagination: { page: number; per_page: number; total: number; total_pages: number };
}

export interface ListActivityParams {
  page?: number;
  pageSize?: number;
  search?: string;
  category?: string;
  date_from?: string;
  date_to?: string;
  scope?: "org" | "platform";
}

export async function listActivity(
  params: ListActivityParams = {},
): Promise<{ items: ActivityEntry[]; total: number }> {
  const pageSize = params.pageSize ?? 50;
  const r = await apiClient().get<ActivityEnvelope>("/activity-feed", {
    params: {
      page: (params.page ?? 0) + 1,
      per_page: pageSize,
      category: params.category && params.category !== "all" ? params.category : undefined,
      search: params.search || undefined,
      date_from: params.date_from || undefined,
      date_to: params.date_to || undefined,
      scope: params.scope ?? "org",
    },
  });
  return { items: r.data.data, total: r.data.pagination.total };
}

export const activityFeedApi = { listActivity };
